import GuidelinesModalLink from 'components/ProductPage/RatingsAndReviews/GuidelinesModalLink/GuidelinesModalLink';

export default GuidelinesModalLink;
